/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IConfirmInternalRegulationObligationRuleControlMappingsMutationVariables = Types.Exact<{
  input: Types.IConfirmInternalRegulationObligationRuleControlMappingsInput;
}>;

export type IConfirmInternalRegulationObligationRuleControlMappingsMutation = {
  __typename?: 'Mutation';
  confirmInternalRegulationObligationRuleControlMappings: boolean;
};

export const ConfirmInternalRegulationObligationRuleControlMappingsDocument = gql`
  mutation ConfirmInternalRegulationObligationRuleControlMappings(
    $input: ConfirmInternalRegulationObligationRuleControlMappingsInput!
  ) {
    confirmInternalRegulationObligationRuleControlMappings(input: $input)
  }
`;
export type IConfirmInternalRegulationObligationRuleControlMappingsMutationFn = Apollo.MutationFunction<
  IConfirmInternalRegulationObligationRuleControlMappingsMutation,
  IConfirmInternalRegulationObligationRuleControlMappingsMutationVariables
>;

/**
 * __useConfirmInternalRegulationObligationRuleControlMappingsMutation__
 *
 * To run a mutation, you first call `useConfirmInternalRegulationObligationRuleControlMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmInternalRegulationObligationRuleControlMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmInternalRegulationObligationRuleControlMappingsMutation, { data, loading, error }] = useConfirmInternalRegulationObligationRuleControlMappingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmInternalRegulationObligationRuleControlMappingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IConfirmInternalRegulationObligationRuleControlMappingsMutation,
    IConfirmInternalRegulationObligationRuleControlMappingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IConfirmInternalRegulationObligationRuleControlMappingsMutation,
    IConfirmInternalRegulationObligationRuleControlMappingsMutationVariables
  >(ConfirmInternalRegulationObligationRuleControlMappingsDocument, options);
}
export type ConfirmInternalRegulationObligationRuleControlMappingsMutationHookResult = ReturnType<
  typeof useConfirmInternalRegulationObligationRuleControlMappingsMutation
>;
export type ConfirmInternalRegulationObligationRuleControlMappingsMutationResult =
  Apollo.MutationResult<IConfirmInternalRegulationObligationRuleControlMappingsMutation>;
export type ConfirmInternalRegulationObligationRuleControlMappingsMutationOptions = Apollo.BaseMutationOptions<
  IConfirmInternalRegulationObligationRuleControlMappingsMutation,
  IConfirmInternalRegulationObligationRuleControlMappingsMutationVariables
>;
